document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[data-menu-toggle]").forEach(function (toggle) {
    const target = document.getElementById(toggle.getAttribute("data-menu-toggle"));
    if (!target) return;
    function closeMenu() { target.classList.remove("open"); toggle.setAttribute("aria-expanded", "false"); }
    toggle.addEventListener("click", function () {
      toggle.setAttribute("aria-expanded", String(target.classList.toggle("open")));
    });
    target.querySelectorAll("a").forEach(function (link) {
      if (new URL(link.href).pathname === location.pathname) link.setAttribute("aria-current", "page");
      link.addEventListener("click", closeMenu);
    });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && target.classList.contains("open")) { closeMenu(); toggle.focus(); }
    });
    document.addEventListener("click", function (event) {
      if (!target.contains(event.target) && !toggle.contains(event.target)) closeMenu();
    });
  });

  document.querySelectorAll("[data-hero-slider]").forEach(function (slider) {
    const slides = [...slider.querySelectorAll(".hero-slide")];
    const dots = [...slider.querySelectorAll(".dot")];
    let index = 0;
    if (!slides.length) return;
    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (slide, n) {
        slide.classList.toggle("active", n === index);
        slide.inert = n !== index;
        slide.setAttribute("aria-hidden", String(n !== index));
      });
      dots.forEach(function (dot, n) {
        dot.classList.toggle("active", n === index);
        dot.setAttribute("aria-pressed", String(n === index));
      });
    }
    slider.querySelectorAll("[data-slide-dir]").forEach(function (button) {
      button.addEventListener("click", function () { show(index + (button.dataset.slideDir === "next" ? 1 : -1)); });
    });
    dots.forEach(function (dot, n) { dot.addEventListener("click", function () { show(n); }); });
    show(0);
  });

  document.querySelectorAll(".pow-product").forEach(function (section) {
    const select = section.querySelector('select[name="id"]');
    const price = section.querySelector("[data-product-price]");
    if (!select || !price) return;
    select.addEventListener("change", function () {
      const option = select.selectedOptions[0];
      if (!option) return;
      price.textContent = option.dataset.price;
      const url = new URL(location.href);
      url.searchParams.set("variant", option.value);
      history.replaceState({}, "", url);
    });
  });

  document.querySelectorAll("[data-contact-form]").forEach(function (form) {
    form.addEventListener("submit", function (event) {
      var valid = true;
      var fields = [
        {
          id: "ContactFormName",
          error: "nameError",
          test: function (v) { return (v || "").trim().length >= 2; },
          message: "Please enter at least 2 characters."
        },
        {
          id: "ContactFormEmail",
          error: "emailError",
          test: function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v || "").trim()); },
          message: "Please enter a valid email address."
        },
        {
          id: "ContactFormSubject",
          error: "subjectError",
          test: function (v) { return (v || "").trim().length > 0; },
          message: "Subject is required."
        },
        {
          id: "ContactFormBody",
          error: "messageError",
          test: function (v) { return (v || "").trim().length >= 10; },
          message: "Message must be at least 10 characters."
        }
      ];

      fields.forEach(function (field) {
        var input = form.querySelector("#" + field.id);
        var error = form.querySelector("#" + field.error);
        if (!input || !error) return;

        if (!field.test(input.value)) {
          valid = false;
          input.classList.add("input-error");
          error.textContent = field.message;
        } else {
          input.classList.remove("input-error");
          error.textContent = "";
        }
      });

      if (!valid) event.preventDefault();
    });
  });
});
